import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './index.scss';
import App from './App';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
// import Router from './routes/routes';
import * as serviceWorker from './serviceWorker';
if (process.env.NODE_ENV !== "development") { console.log = () => { }; }
//console.log("environment",process.env.NODE_ENV)
ReactDOM.render(<I18nextProvider i18n={i18n}>
    <App />
</I18nextProvider>,
    document.getElementById('root'));
// ReactDOM.render( <App /> , document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();